import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class HeadersStore {
  tkn: string | null | undefined;
  tknType: string | null | undefined;

  constructor() {
  }

  /**
   * @description Obtiene los datos del perfil del usuario
   * @returns Observable
   */
  GetTKN() {
    return this.tkn;
  }

  GetTKNType() {
    return this.tknType;
  }

  /**
   * @description  Establece el objeto del perfil  en el store y en el storage
   * @param {MenuItem[]} menu
   */
  SetTKN(tkn: string) {
    this.tkn = tkn;
  }

  SetTKNType(tknType : string) {
    this.tknType = tknType
  }

}
